import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import {
  LIST_VIEW_COLUMNS,
  LIST_VIEW_DEFAULT_SORT,
  LIST_VIEW_DEFAULT_VISIBLE_COLUMNS,
  type ListViewColumnField,
  type ListViewMode,
} from '@air/plugin-ui';

const SIDEBAR_DEFAULT_WIDTH = 256;
export const SIDEBAR_DEFAULT_WIDTH_PX = SIDEBAR_DEFAULT_WIDTH;
export const SIDEBAR_WIDTH_CSS_VAR = '--sidebar-width';

export type ListViewSortPreference = {
  direction: 'asc' | 'desc';
  name: string;
};

type UiPreferencesState = {
  listSort: ListViewSortPreference;
  listVisibleColumns: ListViewColumnField[];
  setListSort: (sort: ListViewSortPreference) => void;
  setListVisibleColumns: (columns: ListViewColumnField[]) => void;
  setViewMode: (viewMode: ListViewMode) => void;
  toggleListColumn: (field: ListViewColumnField) => void;
  viewMode: ListViewMode;
};

export const useUiPreferencesStore = create<UiPreferencesState>()(
  persist(
    (set, get) => ({
      listSort: LIST_VIEW_DEFAULT_SORT,
      listVisibleColumns: LIST_VIEW_DEFAULT_VISIBLE_COLUMNS,
      viewMode: 'gallery',

      setListSort: (sort) => {
        set({ listSort: sort });
      },

      setListVisibleColumns: (columns) => {
        set({ listVisibleColumns: columns });
      },

      setViewMode: (viewMode) => {
        set({ viewMode });
      },

      toggleListColumn: (field) => {
        const current = get().listVisibleColumns;
        const next = current.includes(field) ? current.filter((column) => column !== field) : [...current, field];

        if (next.length === 0) {
          return;
        }

        const columnOrder = LIST_VIEW_COLUMNS.map((column) => column.field);
        next.sort((left, right) => columnOrder.indexOf(left) - columnOrder.indexOf(right));

        set({ listVisibleColumns: next });
      },
    }),
    {
      name: 'air-premiere:ui-preferences',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
